import BootstrapDialog from '@/components/Dialog/BootstrapDialog';
import { StyleCollection } from '@/utils/types';
import { AvatarSentiment, IExpressiveSentiment } from '@d-id/types';
import styled from '@emotion/styled';
import { useEffect, useState } from 'react';
import { SentimentPreview } from './SentimentPreview';
import { SentimentSelection } from './SentimentSelection';

const Container = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
`;

const SelectionWrapper = styled.div`
    flex: 1;
    width: 50%;
`;

const PreviewWrapper = styled.div`
    flex: 1;
    width: 50%;
`;

const styles: StyleCollection = {
    dialogButton: {
        fontSize: '1.6rem',
        alignItems: 'flex-start',
    },
    fieldButton: {
        whiteSpace: 'nowrap',
        fontSize: '14px',
        padding: '4px 6px',
    },
    dialogActions: {
        justifyContent: 'start !important',
    },
    closeIcon: theme => ({
        position: 'absolute',
        top: 16,
        right: 16,
        color: theme.colors.black.main,
    }),
    rootStyle: {
        borderRadius: '24px',
        overflow: 'hidden',
    },
    contentStyle: {
        display: 'flex',
        flexDirection: 'row',
        padding: 0,
        height: '100%',
        overflow: 'hidden',
    },
};

interface Props {
    open: boolean;
    onClose: () => void;
    availableSentiments: IExpressiveSentiment[];
    value: AvatarSentiment;
    onConfirm: (value: AvatarSentiment) => void;
}

export const SentimentModal = ({ open, onClose, availableSentiments, value, onConfirm }: Props) => {
    const [internalSentimentValue, setInternalSentimentValue] = useState<AvatarSentiment>(value);

    useEffect(() => {
        if (open) {
            setInternalSentimentValue(value);
        }
    }, [open, value]);

    const handleClose = () => {
        onClose();
    };

    const handleConfirm = () => {
        onConfirm(internalSentimentValue);
        onClose();
    };

    const previewUrl = availableSentiments.find(sentiment => sentiment.sentiment === internalSentimentValue)?.preview_url || '';

    return (
        <BootstrapDialog
            onClose={handleClose}
            open={open}
            rootstyle={styles.rootStyle}
            contentstyle={styles.contentStyle}
            width="1080px"
            height="780px"
            data-testid="sentiment-modal">
            <Container>
                <SelectionWrapper>
                    <SentimentSelection
                        value={internalSentimentValue}
                        setValue={setInternalSentimentValue}
                        availableSentiments={availableSentiments}
                        onClose={handleClose}
                        onConfirm={handleConfirm}
                    />
                </SelectionWrapper>
                <PreviewWrapper>
                    <SentimentPreview previewUrl={previewUrl} onClose={handleClose} />
                </PreviewWrapper>
            </Container>
        </BootstrapDialog>
    );
};
